// extracted by mini-css-extract-plugin
export default {"howToPayText":"StudentInvoice_howToPayText_lRa4Q"};